export function Hero() {
  return (
    <section className="hero">
      <div className="hero-inner">
        <p className="hero-greeting">Hello, I'm</p>
        <h1 className="hero-name">Paul Ingalls</h1>
        <p className="hero-headline">
          Startup founder, engineer, and entrepreneur building innovative
          services that touch millions of people around the world.
        </p>
        <a href="#contact" className="hero-cta">
          Get in touch
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="5" y1="12" x2="19" y2="12" />
            <polyline points="12 5 19 12 12 19" />
          </svg>
        </a>
      </div>
    </section>
  );
}
